import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { DISPLAY_STATUS_OBJECT, STATUS_OBJECT, STUDENT_FILER_OPTIONS, READING_MEMBER_OBJECT } from 'src/app/dummy/status';
import { ITrainingBatchLevel, ITrainingBatchStudent } from 'src/app/interfaces/training';
import { COLLECTION_NAME, APPS } from 'src/app/dummy/app';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { switchMap, debounceTime, tap } from "rxjs/operators";

@Component({
  selector: 'app-add-batch-level-student',
  templateUrl: './add-batch-level-student.component.html',
  styleUrls: ['./add-batch-level-student.component.scss']
})
export class AddBatchLevelStudentComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;

  form: FormGroup;
  student: AbstractControl;


  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new batch';

  formFocus: boolean;
  search: AbstractControl;
  searchType: AbstractControl;

  filterBy = STUDENT_FILER_OPTIONS;
  loading = false;
  SELECTED_STUDENT: any;

  constructor(
    public dialogRef: MatDialogRef<AddBatchLevelStudentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      searchType: [this.filterBy[0], [Validators.required]],
      search: [null]
    });
    this.search = this.form.controls['search'];
    this.searchType = this.form.controls['searchType'];
    if (this.store.filterType) {
      this.form.patchValue({ searchType: this.store.filterType });
    }
    await this.store.fetchReadingStudent();
    this.search.valueChanges.pipe(
      debounceTime(APPS.DEBOUNCE_TIME),
      tap(() => (this.loading = true)),
      switchMap(value => this.store.fetchFilterReadingStudent(this.form.value.searchType.key, value))
    ).subscribe(results => {
      this.store.data = results;
      this.loading = false;
    });
  }

  displayItem(item: any): string {
    if (this.searchType && this.searchType.value) {
      const { key } = this.searchType.value;
      return item ? item[key] : item;
    }
    return item ? item.fullName : item;
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) {
      return o1.key === o2.key;
    }
  }

  _onFocus(yes) {
    this.formFocus = yes;
  }

  _selectionChange(event) {
    const { value } = event;
    this.store.filterType = value;
  }

  _onSearchInstructor(item) {
    this.SELECTED_STUDENT = item;
  }

  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { search, searchType } = f;
      const { ITEM, BATCH } = this.data;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: ITrainingBatchStudent = {
        key: search.key,
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: ITEM ? ITEM.created_at : new Date(),
        created_by: ITEM ? ITEM.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: ITEM ? ITEM.date_key : ConvertService.dateKey(),
        page_key: ITEM ? ITEM.page_key : ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${search.fullName}`),
        organizationRef: selectedCompanyKey ? this.ds.companyRef().doc(selectedCompanyKey).ref : null,
        organizationKey: selectedCompanyKey || null,
        created_byRef: ITEM ? ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,

        student: search,
        studentRef: this.ds.userMemberListRef(READING_MEMBER_OBJECT.students.key).doc(search.key).ref,
        batchKey: BATCH.key,
        batchRef: this.ds.readingBatchRef().doc(BATCH.key).ref,
      }
      this.store.addStudentBatch(item, BATCH, (success, res) => {
        if (success) {
          this.snackBar.open("Student has been added to batch successful.", "Done", { duration: 1000 });
          if (!isNew) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.form.patchValue({
            searchType: searchType,
          })
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.inputEl.nativeElement.focus()
        }
      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}